import { Amplify } from 'aws-amplify';

// Determine the current domain
const getCurrentDomain = () => {
  if (typeof window !== 'undefined') {
    return window.location.origin + '/';
  }
  return 'http://localhost:3001/';
};

const currentDomain = getCurrentDomain();
console.log('🔵 Current domain for OAuth:', currentDomain);

const amplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId: 'us-east-1_j3P60cED6',
      userPoolClientId: '2pco618qlb7o2r7spmb5j8iff0',
      identityPoolId: 'us-east-1:7d0f4c3a-53b2-4429-b136-be65c934ffa4',
      loginWith: {
        oauth: {
          domain: 'auth.tanisorn.work',
          scopes: ['email', 'openid', 'phone', 'profile'],
          redirectSignIn: [currentDomain],
          redirectSignOut: [currentDomain],
          responseType: 'code'
        },
        email: true,
        username: false
      }
    }
  }
};

console.log('🔵 Amplify OAuth config:', amplifyConfig.Auth.Cognito.loginWith.oauth);

Amplify.configure(amplifyConfig);

export default amplifyConfig;
